import type { ReactElement } from 'react';
import { useCallback, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router';

import { fetchAuthTokens } from '@perpay-web/fintech/actions/authentication';
import { useAppDispatch, useAppSelector } from '@perpay-web/fintech/hooks';
import { paths } from '@perpay-web/fintech/props/appPaths';
import {
    getLoginLoading,
    getErrors,
    getShowWafCaptcha,
    getMFA,
    getIsExistingUser,
} from '@perpay-web/fintech/selectors/authentication';
import type { LoginCredentials } from '@perpay-web/fintech/types/authentication';

import PaychexLoginForm from './PaychexLoginForm';

const PaychexLoginFormContainer = (): ReactElement | null => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const errors = useAppSelector(getErrors);
    const loginLoading = useAppSelector(getLoginLoading);
    const showWafCaptcha = useAppSelector(getShowWafCaptcha);
    const mfa = useAppSelector(getMFA);
    const isExistingUser = useAppSelector(getIsExistingUser);

    const nextParam = searchParams.get('next');

    useEffect(() => {
        if (!nextParam) {
            navigate(paths.paychexSignup.path, { replace: true });
        }
    }, [nextParam, navigate]);

    const onSubmit = useCallback(
        (credentials: LoginCredentials): void => {
            dispatch(fetchAuthTokens(credentials));
        },
        [dispatch],
    );

    if (!nextParam) {
        return null;
    }

    return (
        <PaychexLoginForm
            onSubmit={onSubmit}
            isLoading={loginLoading}
            errors={errors}
            showWafCaptcha={showWafCaptcha}
            mfa={mfa}
            showBanner={isExistingUser}
        />
    );
};

export default PaychexLoginFormContainer;
